import type * as React from 'react';
import { post } from '@Domain/Api';
import userAuthenticated, {
	type AuthenticatedUserPayload,
	type UserAuthenticatedAction,
} from '@Application/Security/Authentications/Actions/userAuthenticated';
import secondFactorRequired, {
	type SecondFactorRequiredAction,
} from '@Application/Security/Authentications/Actions/secondFactorRequired';
import secondFactorEnrollmentRequired, {
	type SecondFactorEnrollmentRequiredAction,
} from '@Application/Security/Authentications/Actions/secondFactorEnrollmentRequired';
import authenticationFailed, {
	type AuthenticationFailedAction,
} from '@Application/Security/Authentications/Actions/authenticationFailed';
import type Login from '@Application/Security/Authentications/Commands/Login';
import extractMessages from '@Infra/FetchLib/ApiError/extractMessages';
import parameters from '../../../parameters';

type LoginResponse =
	| { status: 'authenticated'; user: AuthenticatedUserPayload }
	| { status: 'mfa_required' }
	| { status: 'mfa_enrollment_required' };

type Actions =
	| UserAuthenticatedAction
	| SecondFactorRequiredAction
	| SecondFactorEnrollmentRequiredAction
	| AuthenticationFailedAction;

export default (command: Login) => {
	return async (dispatch: React.Dispatch<Actions>): Promise<Actions> => {
		try {
			const response = await post<LoginResponse>(`${parameters.api.host}/api/login`, command.toJSON(), {
				retryOnUnauthorized: false,
			});

			switch (response.status) {
				case 'authenticated': {
					const action = userAuthenticated(response.user);
					dispatch(action);
					return action;
				}
				case 'mfa_required': {
					const action = secondFactorRequired();
					dispatch(action);
					return action;
				}
				case 'mfa_enrollment_required': {
					const action = secondFactorEnrollmentRequired();
					dispatch(action);
					return action;
				}
				default: {
					throw new Error(`Unhandled login status: ${JSON.stringify(response)}`);
				}
			}
		} catch (error) {
			const action = authenticationFailed(extractMessages(error));
			dispatch(action);
			return Promise.reject(action);
		}
	};
};
